import React from 'react';
import video1 from '../assets/video/001_FireHouseSpirits_Promo.mp4';
import video2 from '../assets/video/002_FireHouseSpirits_Standards.mp4';
import video3 from '../assets/video/003_FireHouseSpirits_Community.mp4';
import './Stories.css';
import SEO from './SEO';

const Stories = () => {
  return (
    <div className="stories-container">
      <SEO
        title="Our Stories"
        description="Discover the stories behind Fire House Spirits, our community, and our brand."
        url="/stories"
      />
      <h1>Our Stories</h1>
      <div className="video-grid">
        <div className="video-item">
          <h2>Fire House Spirits Promo</h2>
          <video controls src={video1} type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="video-item">
          <h2>Fire House Spirits Standards</h2>
          <video controls src={video2} type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="video-item">
          <h2>Fire House Spirits Aesthetics</h2>
          <video controls src={video3} type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
};

export default Stories;
